var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrentLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10187_1831)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10187_1831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8734 33.5724L31.7548 33.609L31.6671 33.6967L27.9513 37.4133L28.3049 37.7668L27.9513 37.4133C27.3657 37.9991 26.4161 37.9991 25.8304 37.4133L21.8396 33.4216L21.7617 33.3437L21.6583 33.3057C15.5465 31.0627 11.187 25.1907 11.187 18.3015C11.187 9.47732 18.3389 2.3241 27.161 2.3241C35.9831 2.3241 43.135 9.47732 43.135 18.3015C43.135 25.4843 38.3958 31.5613 31.8734 33.5724Z",
    fill: "white",
    stroke: "#76BC21"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7399 30.5918C35.9073 29.039 39.6626 24.3475 39.6626 18.8011C39.6626 11.988 33.9962 6.46484 27.0065 6.46484C20.0166 6.46484 14.3503 11.988 14.3503 18.8011C14.3503 24.1208 17.8048 28.6541 22.6467 30.3858L25.7126 33.3743C26.3126 33.9591 27.2853 33.9591 27.8853 33.3743L30.7399 30.5918Z",
    fill: "#76BC21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10187_1831",
    x: 0.687012,
    y: 1.8241,
    width: 52.948,
    height: 56.5286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10187_1831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10187_1831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10187_1831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 59,
    fill: "white",
    transform: "translate(0.160645 0.156128)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationMarker);
export default __webpack_public_path__ + "static/media/currentLocationMarker.85aa707e0425900a39e1e827bb7e398f.svg";
export { ForwardRef as ReactComponent };